module.exports = __webpack_public_path__ + "static/media/mint-background.457ba711.png";